/** SearchBar (06 §4.1 / S22) — local-only filter over chat metadata. */
import { Search, X } from 'lucide-react';
import styles from './SearchBar.module.css';

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}

export function SearchBar({ value, onChange, placeholder = 'Search or start new chat' }: Props) {
  return (
    <div className={styles.wrap}>
      <div className={styles.field}>
        <Search size={18} className={styles.icon} aria-hidden="true" />
        <input
          className={styles.input}
          type="search"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          aria-label="Search chats"
        />
        {value && (
          <button className={styles.clear} onClick={() => onChange('')} aria-label="Clear search">
            <X size={18} />
          </button>
        )}
      </div>
    </div>
  );
}
